import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
    components: { VueUeditorWrap },
    data() {
        return {
            ueConfig: {
                // 如果需要上传功能,找后端小伙伴要服务器接口地址
                // serverUrl: this.$config.baseUrl + 'ueditor/ueditorConfig',
                // serverUrl: 'http://localhost:8090/ueditor/ueditorConfig',
                // 你的UEditor资源存放的路径,相对于打包后的index.html
                UEDITOR_HOME_URL: '/static/UE/',
                // 编辑器不自动被内容撑高
                autoHeightEnabled: false,
                // 工具栏是否可以浮动
                autoFloatEnabled: false,
                // 初始容器高度
                initialFrameHeight: 120,
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 关闭自动保存
                enableAutoSave: true,
                toolbars: [
                    [
                        'fullscreen',
                        'source',
                        '|',
                        'undo',
                        'redo',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        'fontborder',
                        'strikethrough',
                        'superscript',
                        'subscript',
                        'removeformat',
                        'formatmatch',
                        'pasteplain',
                        '|',
                        'forecolor',
                        'backcolor',
                        'insertorderedlist',
                        'insertunorderedlist',
                        '|',
                        'rowspacingtop',
                        'rowspacingbottom',
                        'lineheight',
                        '|',
                        'customstyle',
                        'paragraph',
                        'fontfamily',
                        'fontsize',
                        '|',
                        'indent',
                        '|',
                        'justifyleft',
                        'justifycenter',
                        'justifyright',
                        'justifyjustify',
                        
                    ]
                ]
            }
        }
    }
}